// AI Generated Test
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { AuditImpactService } from '@client/app/modules/page-performance/services/audit-impact/audit-impact.service';
import { PAGE_PERFORMANCE_AUDIT_IMPACT } from '@client/app/modules/page-performance/constants/page-performance-audit-impact';

import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'page-performance-opportunities-by-impact',
    standalone: false,
    template: `
        <div class="opportunities-by-impact-container">
            <div class="opportunities-by-impact-label" translate>
                Opportunities by Priority
            </div>
            <div class="opportunities-by-impact-bar">
                <ngb-progressbar-stacked>
                    <ngb-progressbar type="low-impact"
                                     [value]="lowImpactPercentage"
                                     [ngbTooltip]="lowImpacts.length + ' ' + ('Low Impact Audits' | translate)"
                                     placement="top"
                    >
                    </ngb-progressbar>
                    <ngb-progressbar type="medium-impact"
                                     [value]="mediumImpactPercentage"
                                     [ngbTooltip]="mediumImpacts.length + ' ' + ('Medium Impact Audits' | translate)"
                                     placement="top"
                    ></ngb-progressbar>
                    <ngb-progressbar type="high-impact"
                                     [value]="highImpactPercentage"
                                     [ngbTooltip]="highImpacts.length + ' ' + ('High Impact Audits' | translate)"
                                     placement="top"
                    ></ngb-progressbar>
                </ngb-progressbar-stacked>
            </div>
            <div class="opportunities-by-impact-bar-text d-flex justify-content-between">
                <span>{{ '[[passedAuditsCount]] Checks done' | translate:'':{passedAuditsCount} }}</span>
                <span>{{ '[[notPassedAuditsCount]] Checks to fix' | translate:'':{notPassedAuditsCount} }}</span>
            </div>
            <div class="opportunities-by-impact-bar-legend">
                <div class="impact-pills-container d-flex">
                    <div class="impact-pill high-impact"
                         [ngbTooltip]="'High impact' | translate"
                         [triggers]="'focus hover'"
                         translate>
                         High
                    </div>
                    <div class="impact-pill medium-impact"
                         [ngbTooltip]="'Medium impact' | translate"
                         [triggers]="'focus hover'"
                         translate>
                         Medium
                    </div>
                    <div class="impact-pill low-impact"
                         [ngbTooltip]="'Low impact' | translate"
                         [triggers]="'focus hover'"
                         translate>
                         Low
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PagePerformanceOpportunitiesByImpactComponent implements OnInit, OnChanges {
    @Input() audits: any;

    passedAuditsCount: number = 0;
    notPassedAuditsCount: number = 0;
    highImpactPercentage: number = 0;
    mediumImpactPercentage: number = 0;
    lowImpactPercentage: number = 0;
    impacts: any[] = [];
    highImpacts: any[] = [];
    mediumImpacts: any[] = [];
    lowImpacts: any[] = [];
    passedAudits: any[] = [];
    failedAudits: any[] = [];

    constructor (
        private pagePerformanceAuditImpactService: AuditImpactService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.passedAuditsCount = 0;
        this.notPassedAuditsCount = 0;
        this.highImpactPercentage = 0;
        this.mediumImpactPercentage = 0;
        this.lowImpactPercentage = 0;
        this.impacts = [];
        this.getImpactValues();
    }

    ngOnChanges () {
        this.getImpactValues();
    }

    private getImpactValues () {
        if (!this.audits || this.audits.length === 0) {
            return;
        }

        this.highImpacts = [];
        this.mediumImpacts = [];
        this.lowImpacts = [];
        this.passedAudits = [];
        this.failedAudits = [];

        this.impacts = this.audits.map((audit: any) => {
            return {
                label: this.pagePerformanceAuditImpactService.getImpactTranslation(audit),
                value: this.pagePerformanceAuditImpactService.getImpactValue(audit),
            };
        });

        this.audits.forEach((audit: any) => {
            if (audit.score === 1) {
                this.passedAudits.push(audit);
            } else {
                this.failedAudits.push(audit);
                const impactValue = this.pagePerformanceAuditImpactService.getImpactValue(audit);
                switch (impactValue) {
                    case PAGE_PERFORMANCE_AUDIT_IMPACT.HIGH:
                        this.highImpacts.push(audit);
                        break;
                    case PAGE_PERFORMANCE_AUDIT_IMPACT.MEDIUM:
                        this.mediumImpacts.push(audit);
                        break;
                    case PAGE_PERFORMANCE_AUDIT_IMPACT.LOW:
                        this.lowImpacts.push(audit);
                        break;
                }
            }
        });

        this.highImpactPercentage = this.pipeService.get('monNumber')((this.highImpacts.length * 100) / this.failedAudits.length, '0');
        this.mediumImpactPercentage = this.pipeService.get('monNumber')(
            (this.mediumImpacts.length * 100) / this.failedAudits.length,
            '0',
        );
        this.lowImpactPercentage = this.pipeService.get('monNumber')((this.lowImpacts.length * 100) / this.failedAudits.length, '0');
        this.passedAuditsCount = this.passedAudits.length;
        this.notPassedAuditsCount = this.failedAudits.length;
    }
}
